import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TaskSaveService } from 'app/modules/task/services/task-save.service';
import { DoctorService } from 'app/modules/doctor/services/doctor.service';
import Utils from 'app/Utils';

@Component({
    selector: 'app-autor-filter',
    templateUrl: './autor-filter.component.html',
    styleUrls: ['./autor-filter.component.scss'],
    standalone: false
})
export class AutorFilterComponent implements OnInit {
    authorList: any = [];
    loggedUserTipoAutor: string;
    currentUser: any;
    userList: any = [];
    medicoList: any = [];
    coordinatorList: any = [];
    defaultValue = '';

    @Output() AutorChanged = new EventEmitter();
    @Output() UserChanged = new EventEmitter();
    @Output() MedicoChanged = new EventEmitter();
    @Output() CoordinatorChanged = new EventEmitter();

    dropDownActivate = {
        user: false,
        coordinador: false,
        doctor: false,
    };

    constructor(
        public taskService: TaskSaveService,
        private doctorService: DoctorService
    ) {}

    ngOnInit(): void {
        this.LoadAutorList();
    }

    LoadUserDropdownList(): void {
        this.taskService.GetUsersAbreviacion().subscribe((res) => {
            if (res) {
                this.userList = res.result;
            }
        });
    }

    LoadMedicoDropdownList(): void {
        this.doctorService.GetActiveDoctorsDropdown().subscribe((res) => {
            if (res) {
                this.medicoList = res;
            }
        });
    }

    LoadCoordinatorDropdownList(): void {
        this.taskService.GetActiveCoordinator().subscribe((res) => {
            if (res) {
                this.coordinatorList = res.result;
            }
        });
    }

    LoadAutorList(): void {
        this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        let HasMedicoId = false;
        let HasCoordinator = false;
        if (this.currentUser.medicoId) {
            HasMedicoId = true;
        }
        if (this.currentUser.coordinador) {
            HasCoordinator = true;
        }
        this.authorList = [
            { order: 0, value: '', viewValue: 'Todos', visible: true },
            { order: 1, value: 'Yo', viewValue: 'Yo', visible: true },
            {
                order: 2,
                value: `M`,
                viewValue: 'Yo, como médico',
                visible: HasMedicoId,
            },
            {
                order: 4,
                value: `C`,
                viewValue: 'Yo, como coordinador',
                visible: HasCoordinator,
            },
            { order: 5, value: `G`, viewValue: 'Otro usuario', visible: true },
            { order: 6, value: `M`, viewValue: 'Médico', visible: true },
            { order: 7, value: `C`, viewValue: 'Coordinador', visible: true },
        ];
    }

    OnAuthorChange(event): void {
        if (event) {
            const selectedViewValue = event.source.selected.viewValue;
            const selectedValue = event.source.selected.value;
            this.AutorChanged.emit(selectedValue);
            switch (selectedViewValue) {
                case 'Otro usuario':
                    this.LoadUserDropdownList();
                    this.setOtherDropdownValueForAutorDropdownChange(
                        true,
                        false,
                        false
                    );
                    break;
                case 'Médico':
                    this.LoadMedicoDropdownList();
                    this.setOtherDropdownValueForAutorDropdownChange(
                        false,
                        true,
                        false
                    );
                    break;
                case 'Coordinador':
                    this.LoadCoordinatorDropdownList();
                    this.setOtherDropdownValueForAutorDropdownChange(
                        false,
                        false,
                        true
                    );
                    break;
                default:
                    this.setOtherDropdownValueForAutorDropdownChange(
                        false,
                        false,
                        false
                    );
            }
        }
    }

    setOtherDropdownValueForAutorDropdownChange(
        isUser,
        isDoctor,
        isCoordinator
    ): void {
        this.dropDownActivate.user = isUser;
        this.dropDownActivate.doctor = isDoctor;
        this.dropDownActivate.coordinador = isCoordinator;
    }

    OnValueChange(event: any, type: string): void {
        if (event) {
            const selectedViewValue = event.source.selected.viewValue;
            const selectedValue = event.source.selected.value;
            const obj = { selectedValue, selectedViewValue };

            switch (type) {
                case 'user':
                    const abbreviation = this.userList.filter(
                        (e) => e.value === selectedValue
                    )[0].stringValue;
                    this.UserChanged.emit(abbreviation);
                    break;
                case 'doctor':
                    this.MedicoChanged.emit(obj);
                    break;
                case 'coordinator':
                    this.CoordinatorChanged.emit(selectedViewValue);
                    break;
                default:
                    break;
            }
        }
    }
}
